import { HomeComponent } from "./pages/home/home.component";
import { CityMaster } from "./pages/master/city_master";
import { RoleMasterComponent } from "./pages/master/role-master/role-master.component";
import { UserComponent } from "./pages/master/user/user.component";
import { DropdownComponent } from "./master/dropdown/dropdown.component";
import { FunctionalityComponent } from "./pages/functionality/functionality.component";
import { LoginComponent } from "./pages/login/login.component";
import { Navigation } from "./components/navigation/navigation.component";
import { TaxmasterComponent } from "./pages/master/taxmaster/taxmaster.component";

import { CountryMasterComponent } from "./pages/master/country-master/country-master.component";
import { AirlineMasterComponent } from "./pages/master/airline-master/airline-master.component";
import { AirportMasterComponent } from "./pages/master/airport-master/airport-master.component";


import { FareProductComponent } from "./pages/fare-product-management/fare-product/fare-product.component";
import { RatePerMileComponent } from "./pages/fare-product-management/rate-per-mile/rate-per-mile.component";
import { ExistingBookingsComponent } from "./pages/master/existing-bookings/existing-bookings.component";
import { RecoverpasswordComponent } from "./recoverpassword/recoverpassword.component";
import { ForgotpasswordComponent } from "./forgotpassword/forgotpassword.component";
import { BannermasterComponent } from "./pages/master/bannermaster/bannermaster.component";
import { FarerulesmasterComponent } from "./pages/master/farerulesmaster/farerulesmaster.component";
import { AirlineExclusionComponent } from "./pages/master/airline-exclusion/airline-exclusion.component";
import { ChangepasswordComponent } from "./components/changepassword/changepassword.component";

// import { ReportsComponent } from "./pages/master/reports/reports.component";
import { CrissReedemptionComponent } from "./pages/master/reports/criss-reedemption/criss-reedemption.component";
import { PgReportComponent } from "./pages/master/reports/pg-report/pg-report.component";

import { FTRComponent } from "./pages/master/reports/ftr/ftr.component";
import { AncillaryFTRComponent } from "./pages/master/reports/ancillary-ftr/ancillary-ftr.component";

import { AuditLogComponent } from "./pages/master/reports/audit-log/audit-log.component";
import { OrderManagementComponent } from "./pages/master/order-management/order-management.component";
import { OrderBookingComponent } from "./pages/master/order-booking/order-booking.component";
import { FareFamilyComponent } from "./pages/supplier-management/fare-family/fare-family.component";
import { MilesConfigureComponent } from "./pages/supplier-management/miles-configure/miles-configure.component";
import { GetFareProductComponent } from "./pages/master/get-fare-product/get-fare-product.component";
import { TPMComponent } from "./pages/master/tpm/tpm.component";
// import { LogsComponent } from "./logs/logs.component";
import { UBCONVFEETPMComponent } from "./pages/master/ub-conv-fee-tpm/ub-conv-fee-tpm.component";


import { CancellationMasterComponent } from "./pages/master/cancellation-master/cancellation-master.component";
import { CancelBookingComponent } from "./pages/master/cancel-booking/cancel-booking.component";
// import { CancellationManagementComponent } from "./pages/master/Cancellation-management/Cancellation-management.component";
import { InsuranceMasterComponent } from "./pages/master/insurance-master/insurance-master.component";
import { ManageOfferComponent } from './pages/manage-offer/manage-offer.component';
import { MilesXandYComponent } from './pages/miles-xand-y/miles-xand-y.component';
import { MilesConfigurationComponent } from './pages/miles-configuration/miles-configuration.component';
import { OverridePriceComponent } from './pages/override-price/override-price.component';

import { InsuranceProviderMasterComponent } from "./pages/master/insurance-provider-master/insurance-provider-master.component";
import { SsrMasterComponent } from "./pages/master/ssr-master/ssr-master.component";
import { AncellariesDescriptionComponent } from "./pages/master/ancellaries-description/ancellaries-description.component";

import { ConvFeeTpmComponent } from "./pages/conv-fee-tpm/conv-fee-tpm.component";

import { DeltaDataUploadComponent } from "./pages/master/delta-data-upload/delta-data-upload.component";
import { CreditShellReportComponent } from "./pages/master/reports/credit-shell-report/credit-shell-report.component";
import { DsrOneGComponent } from "./pages/supplier-management/dsr-oneg/dsr-oneg.component";

import { HideAncillaries } from "./pages/master/hide-ancillaries/hide-ancillaries.component";
import { FcrComponent } from "./pages/master/reports/fcr/fcr.component"
import { BannerNewComponent } from "./pages/master/banner-new/banner-new.component";
import { EmailFtrComponent } from "./pages/master/reports/email-ftr/email-ftr.component";
import { SearchFlightsComponent } from "./pages/search-flights/search-flights.component";
import { EarnRefundFtrComponent } from "./pages/earn-refund-ftr/earn-refund-ftr.component";
import { ExceptionReportComponent } from "./pages/master/reports/exception-report/exception-report.component"
// Navigation;

export const appRoutes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full"
  },
  // {
  //     path: 'home',
  //     component: HomeComponent,
  //     children: [
  //         { path: 'city_master', component: CityMaster },
  //         { path: 'country_master', component: CountryMasterComponent }
  //     ]
  // },
  {
    path: "rolemaster",
    component: RoleMasterComponent
  },
  {
    path: "recover",
    component: RecoverpasswordComponent
  },
  {
    path: "forgot",
    component: ForgotpasswordComponent
  },
  {
    path: "others",
    loadChildren: () => import('./pages/others/others.module').then(m => m.OthersModule)
  },
  {
    path: "city_master",
    component: CityMaster
  },
  {
    path: "country_master",
    component: CountryMasterComponent
  },
  {
    path: "tax",
    component: TaxmasterComponent
  },
  {
    path: "user",
    component: UserComponent
  },
  {
    path: "login",
    component: LoginComponent
  },
  // {
  //   path: "create_credential",
  //   component: CreateCredentialComponent
  // },
  // {
  //   path: "credential_field",
  //   component: CredentialFieldComponent
  // },
  {
    path: "fare_product",
    component: FareProductComponent
  },
  // {
  //     path: 'functionality',
  //     component: FunctionalityComponent
  // },
  {
    path: "dropdown",
    component: DropdownComponent
  },

  {
    path: "navigation",
    component: Navigation,
    children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      { path: "home", component: HomeComponent },
      { path: "rolemaster", component: RoleMasterComponent },
      { path: "city_master", component: CityMaster },
      { path: "country_master", component: CountryMasterComponent },
      { path: "user", component: UserComponent },
      { path: "airline", component: AirlineMasterComponent },
      { path: "airport", component: AirportMasterComponent },
      { path: "fare_product", component: FareProductComponent },
      { path: "functionality", component: FunctionalityComponent },
      { path: "tax", component: TaxmasterComponent },
      //{ path: "smstemplate", component: SmsTemplateComponent },
      { path: "rate_per_mile", component: RatePerMileComponent },
      { path: "existingbooking", component: ExistingBookingsComponent },
      { path: "delta_data_upload", component: DeltaDataUploadComponent },

      { path: "banner", component: BannermasterComponent },
      { path: "farerules", component: FarerulesmasterComponent },
      { path: "airlineexclusion", component: AirlineExclusionComponent },
      { path: "changePassword", component: ChangepasswordComponent },

      // { path: "report", component: ReportsComponent },
      { path: "PgReport", component: PgReportComponent },
      { path: "CrissReedemptionReport", component: CrissReedemptionComponent },
      { path: "ftr", component: FTRComponent },
      { path: "fcr", component: FcrComponent },
      { path: "ancillary-ftr", component: AncillaryFTRComponent },
      { path: "CreditShellReport", component: CreditShellReportComponent },
      { path: 'emailFTR', component: EmailFtrComponent },
      { path: "auditlog", component: AuditLogComponent },
      { path: "ordermanage", component: OrderManagementComponent },
      // { path: "ordermanage:id", component:OrderManagementComponent},
      { path: "orderbooking", component: OrderBookingComponent },
      { path: "farefamily", component: FareFamilyComponent },
      { path: "milesconfigure", component: MilesConfigureComponent },
      { path: "tpm", component: TPMComponent },
      { path: "getFareProduct", component: GetFareProductComponent },
      // { path: "logs", component: LogsComponent },
      { path: "fee_tpm", component: UBCONVFEETPMComponent },
      { path: "cancellation", component: CancellationMasterComponent },
      { path: "CancelBooking", component: CancelBookingComponent },
      // { path: "CancellationManagement", component: CancellationManagementComponent },
      { path: "insurance", component: InsuranceMasterComponent },
      { path: "OverridePrice", component: OverridePriceComponent },
      { path: "insurance_provider", component: InsuranceProviderMasterComponent },
      { path: "milesConfiguration", component: MilesConfigurationComponent },
      { path: "milesXandY", component: MilesXandYComponent },
      { path: "manageOffer", component: ManageOfferComponent },
      { path: "ssr", component: SsrMasterComponent },
      { path: "ansdescription", component: AncellariesDescriptionComponent },
      // { path: "milesConfigurationNew", component: MilesConfigurationNewComponent },
      { path: "conv_fee_tpm", component: ConvFeeTpmComponent },
      { path: "dsr_oneg", component: DsrOneGComponent },
      { path: "contents", component: BannerNewComponent },
      { path: 'enable_disable_ancillaries', component: HideAncillaries },
      { path: 'searchcomparer', component: SearchFlightsComponent },
      { path: 'RefundFtr', component: EarnRefundFtrComponent },
      { path: 'exception-report', component: ExceptionReportComponent },
    ]
  }
];
